export default {
  permissionMenuMap: {
    'dashboard': '控制面板',
    'admin': '管理',
    'admin:user': '用户',
    'admin:role': '角色',
    'admin:permission': '权限',
    'admin:driver': '司机',
    'admin:car': '车库',
    'admin:userOrder': '用户订单'
  }
};



// WEBPACK FOOTER //
// ./src/constant.js